import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiChangeInvoiceEmailRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const changeInvoiceEmail = async (
  instance: AxiosInstance,
  params: DefaultApiChangeInvoiceEmailRequest
) => {
  return await userApiDefaultApiFactory(instance).changeInvoiceEmail(params)
}

// Do Not Remove this line ===@import api client===
